import React, { useEffect } from 'react';
import './AudioPlayer.css';

const AudioPlayer = ({ src, title }) => {
  useEffect(() => {
    console.log(`Current track: ${title} (${src})`);
  }, [src, title]);

  return (
    <div className="audio-player-container">
      <h3 className="audio-player-title">{title}</h3>
      {/* Key ensures the audio player is destroyed and recreated on src change */}
      <audio key={src} controls className="custom-audio-player">
        <source src={src} type="audio/mp3" />
        Your browser does not support the audio element.
      </audio>
    </div>
  );
};

export default AudioPlayer;